import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {CompetitionBracketsPageConfig} from "./competition-brackets-page.config";
import {CompetitionBracketsPageState} from "./models/competition-brackets-page.state";

export class CompetitionBracketsPageStore extends BaseMobxStore {
  static injectables = [CompetitionBracketsPageConfig, CompetitionBracketsPageState];

  state: CompetitionBracketsPageState;
}
